/** Set REACT_APP_USE_CASHFREE=true when Cashfree live transactions are enabled. */
export const USE_CASHFREE_PAYMENTS =
  process.env.REACT_APP_USE_CASHFREE === "true";

export const MERCHANT_UPI_ID = "infinitywhale@sbi";
export const QR_CODE_IMAGE_PATH = "/qrcode-new.png";

export const BANK_DETAILS = {
  accountName: "Infinity Whale",
  accountNumber: "44565656778",
  ifsc: "SBIN0063847",
  branch: "BSF STC Yelahanka",
};
